import "./Promotions.css";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useAppImages from "./components/AppImages";
import { useConfigsQuery } from "./components/queries";
import ReactHtmlParser from "html-react-parser";
import "./Global.js";
import ReactGA from "react-ga4";


const strapiServerUrl = window.strapiServerUrl;

const Promotions = () => {
  const { loading, error, data } = useConfigsQuery();
  const [appImages, sectionDesc] = useAppImages();
  const [promotionImage, setPromotionImage] = useState(null);
  const [promotionDesc, setPromotionDesc] = useState(null);
  const [promotionData, setPromotionData] = useState(null);

  useEffect(() => {
    if (appImages) {
      setPromotionImage(appImages["promotions"]);
    }
    if (sectionDesc) {
      setPromotionDesc(sectionDesc["promotions"]);
    }
  }, [appImages, sectionDesc]);

  useEffect(() => {
    if (data) {
      setPromotionData(data.promotions.data);
    }
  }, [data]);

  const handleClick = (section) => {
    ReactGA.event({
      category: 'PromotionIcon',
      action: 'Click',
      label: `${section}`,
    });
  };


  return (
    <div className="promotion-container" id="promotions">
      <div className="promotion-image-section">
        {promotionImage && (
          <img
            className="promotion-image"
            src={`${strapiServerUrl}${promotionImage}`}
            alt="promotions"
          />
        )}
        <div className="promotion-dialog-box">
          <h1>Promotions</h1>
          {promotionDesc && ReactHtmlParser(promotionDesc)}
        </div>
      </div>
      <div className="promotion-icon-section">
        <div className="promotion-icon-grid">
          {loading ? (
            <div>Loading...</div>
          ) : error ? (
            <div>Error: {error.message}</div>
          ) : (
            promotionData &&
            promotionData.map((item, index) => (
              <Link
                to={`/promotions/details`}
                state={{ sectionId: item.attributes.promotion_name }}
                onClick={() => handleClick(item.attributes.promotion_name)}
                key={index}
              >
                <div className="promotion-icon-item">
                  <div className="promotion-icon">
                    <img
                      src={`${strapiServerUrl}${item.attributes.promo_icon.data.attributes.url}`}
                      alt="icon"
                    />
                  </div>
                  <div className="promotion_name">
                    {item.attributes.promotion_name}{" "}
                  </div>
                </div>
              </Link>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Promotions;
